var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import { connectComponent } from '../../redux/utils';
import { mdiArrowLeft } from '@mdi/js';
import { ButtonIcon } from 'grilnica-reactstrap';
var ButtonBack = /** @class */ (function (_super) {
    __extends(ButtonBack, _super);
    function ButtonBack() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonBack.prototype.render = function () {
        var _a = this.props, goBack = _a.goBack, title = _a.title, classNameContainer = _a.classNameContainer, classNameTitle = _a.classNameTitle, classNameIcon = _a.classNameIcon, isNotHoverIcon = _a.isNotHoverIcon;
        return (React.createElement("div", { className: 'd-flex flex-row align-items-center justify-content-start ' +
                (classNameContainer ? classNameContainer : '') },
            React.createElement(ButtonIcon, { iconPath: mdiArrowLeft, size: 'md', onClick: goBack, title: 'Назад', className: (title ? 'mr-2 ' : 'mr-0 ') + (classNameIcon ? classNameIcon : '') }),
            title && (React.createElement("h3", { className: 'mb-0 ' + (classNameTitle ? classNameTitle : ''), onClick: goBack }, title))));
    };
    return ButtonBack;
}(Component));
export default connectComponent(function (state, props) { return ({
    goBack: props.history.goBack,
}); }, function () { return ({}); }, ButtonBack);
//# sourceMappingURL=ButtonBack.js.map